import { render, staticRenderFns } from "./FailureAccess.vue?vue&type=template&id=865a7240&scoped=true"
import script from "./FailureAccess.vue?vue&type=script&lang=js"
export * from "./FailureAccess.vue?vue&type=script&lang=js"
import style0 from "./FailureAccess.vue?vue&type=style&index=0&id=865a7240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865a7240",
  null
  
)

export default component.exports